import * as React from "react";
const SvgAddBig = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#111", fillRule: "evenodd", d: "M13 11h5v2h-5v5h-2v-5H6v-2h5V6h2v5z", clipRule: "evenodd" }));
export default SvgAddBig;
